import {SOPostBacklog} from '../../core/backlog/so-post-backlog';
import {BacklogCore} from './backlog.core';
import {SOGetBacklog} from '../../core/backlog/so-get-backlog';
import {FormField, SelectionOption} from 'lionheartland';
import {postBacklogFormFieldOptions} from './post-backlog-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePost} from 'lionheartland';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPostBacklog extends BasePost implements AdapterProtocol {
  formFieldOptions = Object.values(postBacklogFormFieldOptions);

  RequestClass = SOPostBacklog

  constructor(
    public entityCore: BacklogCore
  ) {
    super();
    if (postBacklogFormFieldOptions.project) {
      postBacklogFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
      this.getFormValueFromIdentifier('description'),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}